// Render a DATE-ONLY value (e.g. "2026-12-31") as the exact stored calendar date,
// WITHOUT timezone conversion. Using `new Date("2026-12-31")` parses as UTC midnight
// and shifts to the previous day in behind-UTC zones; we parse the parts as a LOCAL date.
// Only for date-only fields — do NOT use for full timestamps (audit times etc.).
export function formatDateOnly(value) {
  if (!value) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(value);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
}
